module.exports = __webpack_public_path__ + "img/ico_fb.3caa92ef.svg";